import React, {Component} from 'react'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  getVideos,
  getSettings,
  getPhotos,
  sendMessage,
  getTracks
} from '../../modules/nv'
import scrollToComponent from 'react-scroll-to-component'
import Header from './header.js'
import About from './about.js'
import Film from './film.js'
import Contact from './contact'
import Services from './services'
import Music from './music'
import Photography from './photography'
import Footer from './footer'

class Home extends Component {

  componentWillMount = () => {
    this.props.getVideos()
    this.props.getSettings()
    this.props.getPhotos()
    this.props.getTracks()
  }

  componentDidMount = () => {
    if(this.props.match.params.section) {
      this.scrollToElement(this.props.match.params.section)
    }
  }

  scrollToElement = target => {
    scrollToComponent(document.querySelector(`.${target}`), {
      align: 'top',
      duration: 400
    })
  }

  handleActive = section => {
    document.title = section.title
    this.props.changePath(section.target)
  }

  render() {
    const { settings, sendMessage, messageSent, tracks } = this.props
    return(
      <div ref="main">
          
          <Header 
            texts={settings.header_headlines}
            socials={settings.social_links}
            scroll={this.scrollToElement} 
            onActive={this.handleActive}
            toggleSidebar={this.props.toggleSidebar}
            sideMenuActive={this.props.sideMenuActive}
          />
        
          <About />
          <Film videos={this.props.videos}/>
          <Photography photos={this.props.photos} />
          <Music tracks={tracks} />
          <Services />
          <Contact 
            sendMessage={sendMessage}
            sent={messageSent}
          />
          <Footer 
            scroll={this.scrollToElement}
            socials={settings.social_links}
          />

      </div>
    )
  }
}

const mapStateToProps = state => ({
  videos: state.nv.videos,
  settings: state.nv.settings,
  photos: state.nv.photos,
  tracks: state.nv.tracks,
  messageSent: state.nv.messageSent
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getVideos,
  getSettings,
  getPhotos,
  sendMessage,
  getTracks,
  changePath: path => push(path)
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./src/containers/home/index.js